export default {
  en: {
    pkking: 'PK King',
    supporter: 'Booster King',
    room: 'Room',
    rewardKing: 'Rewards for PK king',
    rewardSupporter: 'Rewards for Booster',
    rewardRoom: 'Rewards for Room',
    timeR: 'Count down ',
    days: 'days',
    rule: 'Rule',
    lastweek: 'Top 3 of last week',
    thisweek: 'Rank of this week',
    rule1:
      '1. The weekly activity cycle is from 0:00 on Sunday to 23:59:59 on Saturday, KSA time.(scores right before the end of countdown will be counted into the week cycle)',
    rule2: '2. The PK King is ranked according to the scores gained in pk competition.',
    rule3: '3. The Booster King is ranked according to the scores given in pk competition.',
    rule4:
      '4. Using gifts in all other activities to participate in PK, the corresponding scores will not be counted in the PK list.',
    HonorList: 'Honor List',
    rule5: '5. Every competition, the winner will get a 3% share.',
    service: 'If you have questions, please click here to contact customer service.',
    rewardtitle: 'Reward Rules',
    rewardRule: `
    - Regarding the headwear and the car : You can take a headwear and a car, whichever position the user won.<br/><br/>
    - Regarding the badge: The badge can only be taken in the case of completing the points of the position in which the user won, and it cannot be exchanged for any other badge for the rest of the centers.<br/><br/>
    - Regarding the coins: in the event that the user wins one of the centers, for example (a user won the first place, but his points, for example, 500k, means less than 800k, which are the requirements to obtain coins, in this case he will take the first place headwear + the first place car + the first place badge + and he can get  for second-place coins because he met the condition for second-place coins, which is more than 400k).<br/><br/>
    But in the event that he was a winner in the first place with less than 500k points, for example, 400k means less even than the points of the first badge , In this case, he will take the headwear and the car for the first place and the second place coins only, which means rewards without a badge.
    `
  },
  ar: {
    pkking: 'ملك PK',
    supporter: 'ملك الدعم ',
    room: 'غرفة',
    rewardKing: 'PK الملك مكافأة',
    rewardSupporter: 'مكافئات داعم pk',
    rewardRoom: 'مكافئات الغرف',
    timeR: 'العد التنازلي ',
    days: 'أيام',
    rule: 'القواعد',
    lastweek: 'أعلى ثلاثة في الأسبوع الماضي',
    thisweek: 'ترتيب الأسبوع',
    rule1:
      'تبدأ دورة النشاط الأسبوعية من الساعة 0:00 يوم الأحد وحتى الساعة 23:59:59 يوم السبت بتوقيت المملكة العربية السعودية (سيتم احتساب النتائج قبل نهاية العد التنازلي مباشرة في دورة الأسبوع) ؛',
    rule2: 'يتم تصنيف PK King وفقًا للدرجات التي تم الحصول عليها في مسابقة pk ؛',
    rule3: 'يتم ترتيب الملك المعزز وفقًا للدرجات المعطاة في مسابقة pk.',
    rule4: 'باستخدام الهدايا في جميع الأنشطة الأخرى للمشاركة في القتل ، لن يتم احتساب الدرجات المقابلة في قائمة القتل.',
    HonorList: 'قائمة الشرف',
    rule5: 'في كل مسابقة ، سيحصل الفائز على حصة 3٪',
    service: 'إذا كانت لديك اي مشكله  ، يرجى النقر هنا للتواصل مع خدمة العملاء أحلام ',
    rewardtitle: 'قواعد المكافأة',
    rewardRule: `
- بخصوص الاطار و السيارة : يمكن اخد غطاء راس و سيارة اي مركز فاز فيه المستخدم <br/><br/>
- بخصوص الشارة : لا يمكن اخد الشارة الا في حالة اكمال نقاط المركز الذي فاز فيه المستخدم و لا يمكن استبدالها باي شاره اخرى لباقي المراكز <br/><br/>
- بخصوص الكونزات : في حالة فوز المستخدم باحد المراكز على سبيل المثال ( فاز مستخدم بالمركز الاول لكن نقاطه  مثلا 005k يعني اقل من 008k التي هي متطلبات الحصول على كونزات في هذه الحاله سياخد اطار المركز الاول + سيارة المركز الاول + شارة المركز الاول + و يمكنه الحصول على كونزات المركز الثاني لانه حقق شرط كونزات المركز الثاني الذي هو اكثر من 004k ) <br/><br/>
لكن في حالة كان فائز في المركز الاول بنقاط اقل من 005k مثلا 004k يعني اقل حتى من نقاط الشارة الاولى في هذه الحالة سياخد الاطار و السيارة للمركز الاول و كونزات المركز الثاني فقط يعني مكافئات بدون شارة 
    `
  },
  tr: {
    pkking: 'Pk Kralı',
    supporter: 'Destek',
    room: 'oda',
    rewardKing: 'Pk Kralı Ödülleri',
    rewardSupporter: 'Destek Ödülleri',
    rewardRoom: 'Oda için geri ödül',
    timeR: 'Kalan Süre: ',
    days: 'gün',
    rule: 'Kurallar',
    lastweek: 'Geçen hafta üçüncü',
    thisweek: 'Bu hafta boyunca',
    rule1: "1- Haftalık etkinlik döngüsü Türkiye Saati ile Pazar 23:59:59'dan Pazar 23:59:59'a Kadardır.",
    rule2: '2- Pk Kralı pk yarışmasında kazandığı puanlara göre sınırlanır.',
    rule3: '3- Destekçi Kralı pk yarışmasında kazandığı puanlara göre sınırlandırılır.',
    rule4:
      '4- Başka etkinliklere özel hediyeleri kullanarak pk yarışmasına katılırsa kazandığı puan pk listesine sayılmaz.',
    HonorList: 'Saygı Listesi',
    rule5: '5. Her yarışmada kazanan %3 pay alacak.',
    service: 'Sorularınız varsa lütfen servisle iletişime geçmek için buraya tıklayın',
    rewardtitle: 'Ödül Kuralları',
    rewardRule: `
    - Şapka ve araba ile ilgili : Kullanıcı hangi pozisyonda kazanırsa kazansın, şapka ve araba alabilirsiniz.<br/><br/>
    - Rozetle ilgili olarak: Rozet, yalnızca kullanıcının kazandığı pozisyonun puanlarını tamamlaması durumunda alınabilir ve diğer merkezler için başka bir rozetle değiştirilemez.<br/><br/ >
    - Madeni paralarla ilgili olarak: örneğin kullanıcının merkezlerden birini kazanması durumunda (bir kullanıcı birinciliği kazandı, ancak puanları, örneğin 500k, jeton elde etmek için gerekli olan 800k'dan az anlamına gelir, bu durumda birincilik şapkası + birincilik araba + birincilik rozeti + alacak ve ikincilik jetonları için 400 binden fazla olan ikincilik jeton koşulunu karşıladığı için ikincilik jetonları alabilecek.<br/ ><br/>
    Ancak ilk etapta 500 binden az puanla kazanan olması durumunda, örneğin 400k, ilk rozetin puanlarından bile daha az anlamına gelir, Bu durumda, şapkayı ve arabayı ilk etapta alacaktır. ve sadece ikinci sıradaki jetonlar, yani rozetsiz ödüller.
    `
  },
  pt: {
    pkking: 'Rei do PK',
    supporter: 'Rei do Apoio',
    room: 'Sala',
    rewardKing: 'Recompensas para o Rei do PK',
    rewardSupporter: 'Recompensas para o Apoiante',
    rewardRoom: 'Recompensas para a Sala',
    timeR: 'Contagem regressiva',
    days: 'dias',
    rule: 'Regra',
    lastweek: 'Top 3 da semana passada',
    thisweek: 'Ranking desta semana',
    rule1:
      '1. O ciclo da atividade semanal vai de 0:00 no domingo até 23:59:59 no sábado, horário da KSA. (os pontos imediatamente antes do final da contagem regressiva serão contados no ciclo da semana)',
    rule2: '2. O Rei do PK é classificado de acordo com os pontos obtidos na competição de PK.',
    rule3: '3. O Rei do Apoio é classificado de acordo com os pontos dados na competição de PK.',
    rule4:
      '4. Usar presentes de todas as outras atividades para participar do PK, os pontos correspondentes não serão contados na lista de PK.',
    HonorList: 'Lista de Honra',
    rule5: '5. Em cada competição, o vencedor receberá uma parte de 3%.',
    service: 'Se você tiver dúvidas, clique aqui para contatar o atendimento ao cliente.',
    rewardtitle: 'Regras de Recompensa',
    rewardRule: `
    - Quanto ao acessório e ao carro: Você pode pegar um acessório e um carro, independentemente da posição que o usuário tenha conquistado.<br/><br/>
    - Quanto ao distintivo: O distintivo só pode ser obtido se você completar os pontos da posição em que o usuário venceu, e não pode ser trocado por nenhum outro distintivo para os outros centros.<br/><br/>
    - Quanto às moedas: no caso de o usuário ganhar uma das posições, por exemplo, (um usuário ganhou o primeiro lugar, mas seus pontos, por exemplo, 500k, são inferiores a 800k, que são os requisitos para obter moedas, nesse caso ele levará o acessório do primeiro lugar + o carro do primeiro lugar + o distintivo do primeiro lugar + ele poderá receber as moedas do segundo lugar porque atendeu à condição para as moedas do segundo lugar, que é mais de 400k).<br/><br/>
    Mas se ele foi um vencedor no primeiro lugar com menos de 500k pontos, por exemplo, 400k, o que significa menos até do que os pontos do primeiro distintivo, nesse caso ele levará o acessório e o carro do primeiro lugar e as moedas do segundo lugar apenas, o que significa recompensas sem distintivo.
    `
  },
  id: {
    pkking: 'Raja PK',
    supporter: 'Raja Booster',
    room: 'Kamar',
    rewardKing: 'Hadiah untuk Raja PK',
    rewardSupporter: 'Hadiah untuk Booster',
    rewardRoom: 'Hadiah untuk Kamar',
    timeR: 'Hitung mundur ',
    days: 'hari',
    rule: 'Aturan',
    lastweek: 'Top 3 minggu lalu',
    thisweek: 'Peringkat minggu ini',
    rule1:
      '1. Siklus kegiatan mingguan adalah dari pukul 00:00 pada hari Minggu hingga pukul 23:59:59 pada hari Sabtu, waktu KSA. (skor tepat sebelum akhir hitung mundur akan dihitung dalam siklus minggu ini)',
    rule2: '2. Raja PK diperingkat berdasarkan skor yang diperoleh dalam kompetisi pk.',
    rule3: '3. Raja Booster diperingkat berdasarkan skor yang diberikan dalam kompetisi pk.',
    rule4:
      '4. Menggunakan hadiah dalam semua kegiatan lain untuk berpartisipasi dalam PK, skor yang sesuai tidak akan dihitung dalam daftar PK.',
    HonorList: 'Daftar Kehormatan',
    rule5: '5. Setiap kompetisi, pemenang akan mendapatkan 3% bagian.',
    service: 'Jika Anda memiliki pertanyaan, silakan klik di sini untuk menghubungi layanan pelanggan.',
    rewardtitle: 'Aturan Hadiah',
    rewardRule: `
    - Mengenai penutup kepala dan mobil: Anda dapat mengambil penutup kepala dan mobil, sesuai dengan posisi yang dimenangkan oleh pengguna.<br/><br/>
    - Mengenai lencana: Lencana hanya dapat diambil jika menyelesaikan poin dari posisi yang dimenangkan oleh pengguna, dan tidak dapat ditukar dengan lencana lain di pusat lainnya.<br/><br/>
    - Mengenai koin: dalam hal pengguna memenangkan salah satu pusat, misalnya (seorang pengguna memenangkan tempat pertama, tetapi skornya, misalnya, 500k, berarti kurang dari 800k, yang merupakan persyaratan untuk mendapatkan koin, dalam hal ini dia akan mengambil penutup kepala tempat pertama + mobil tempat pertama + lencana tempat pertama + dan dia bisa mendapatkan koin tempat kedua karena dia memenuhi syarat untuk koin tempat kedua, yang lebih dari 400k).<br/><br/>
    Namun, dalam hal dia adalah pemenang di tempat pertama dengan kurang dari 500k poin, misalnya, 400k berarti kurang dari poin lencana pertama, dalam hal ini, dia hanya akan mengambil penutup kepala dan mobil untuk tempat pertama dan koin tempat kedua, yang berarti hadiah tanpa lencana.
    `
  },
  ru: {
    pkking: 'Король баттлов',
    supporter: 'Король сторонников',
    room: 'Комната',
    rewardKing: 'Награды',
    rewardSupporter: 'Награды',
    rewardRoom: 'Награды',
    timeR: 'Обратный отсчет',
    days: 'дни',
    rule: 'Правила',
    lastweek: 'Топ-3 за прошлую неделю',
    thisweek: 'Топ-3 прошлой недели',
    rule1:
      '1. Цикл этого еженедельного  мероприятия длится с 0:00 воскресенья по 23:59:59 субботы по московскому времени (Очки, полученные до окончания обратного отсчета, будут подсчитаны в цикле этой недели)',
    rule2: '2. Рейтинг Короля баттлов определяется в соответствии с очками, полученные в ходе соревнований по баттлам.',
    rule3:
      '3. Рейтинг Короля сторонников определяется в соответствии с очками, отданные в ходе соревнований по баттлам.',
    rule4:
      '4. Вы можете выбрать подарок в качестве баттл-подарка. Вы можете получить баттл-очки только в том случае, если получите или передадите этот баттл-подарок.',
    HonorList: 'Список Почета',
    rule5:
      '5. После каждого баттла  победитель будет получать золотые монеты, сумма которых составляет 3％ от баттл-очок.',
    service: 'Если у вас есть вопросы, нажмите здесь для связи с официальным представителем.',
    rewardtitle: 'Правила наград',
    rewardRule:
      '- Что касается головного убора и драйва: вы можете получить головной убор и драйв, в зависимости от того, какое место занял пользователь.<br/><br/>- Что касается значка: значок можно получить только при выполнении требований по очкам за место, и он не может быть обменян на другие значки для остальных мест.<br/><br/>- Что касается монет: если пользователь выигрывает одно из мест, например (пользователь занял ТОП-1, но его очки, например, 500k, меньше 800k, что является требованием первого места для получения монет, в этом случае он получит головной убор первого места + драйв первого места + значок первого места + и он может получить монеты для второго места, так как выполнил условие для второго места, которое составляет более 400k).<br/><br/>- Что касается значка:  если он занял ТОП-1 с менее чем 500k очками, например 400k, что меньше даже очков первого значка, в этом случае он получит головной убор и драйв первого места, а также только монеты второго места, то есть награды без значка.'
  },
  uz: {
    pkking: 'Janglar qiroli',
    supporter: 'Tarafdorlar qiroli',
    room: 'Xona',
    rewardKing: 'Mukofotlar',
    rewardSupporter: 'Mukofotlar',
    rewardRoom: 'Mukofotlar',
    timeR: 'Ortga hisoblash',
    days: 'kunlar',
    rule: 'Qoidalar',
    lastweek: "O'tgan haftadagi eng yaxshi 3",
    thisweek: 'Ushbu haftaning reytingi',
    rule1:
      '1. Ushbu haftalik tadbirning tsikli yakshanba kuni soat 0: 00 dan Moskva vaqti bilan shanba kuni soat 23:59:59 gacha davom etadi (ortga hisoblash tugashidan oldin olingan ballar shu hafta tsiklida hisoblanadi)',
    rule2: '2. Battle King reytingi Battle musobaqalari davomida olingan ochkolarga muvofiq belgilanadi.',
    rule3: '3. Qirol tarafdorlarining reytingi jang musobaqalari davomida berilgan ochkolarga muvofiq belgilanadi.',
    rule4:
      "4. Siz sovg'ani jang sovg'asi sifatida tanlashingiz mumkin. Agar siz ushbu jang sovg'asini olsangiz yoki topshirsangiz, faqat jang ballarini olishingiz mumkin.",
    HonorList: "Faxriy Yorliqlar Ro'yxati",
    rule5: "5. Har bir jangdan so'ng g'olib oltin tangalarni oladi, ularning yig'indisi 3 бат dan jang nuqtasi.",
    service: "Agar sizda biron bir savol bo'lsa, rasmiy vakil bilan bog'lanish uchun shu erni bosing.",
    rewardtitle: 'Mukofot qoidalari',
    rewardRule:
      "- Bosh kiyim va haydovchiga kelsak: foydalanuvchi qaysi joyni egallaganiga qarab, siz bosh kiyim va haydovchini olishingiz mumkin.<br/> < br/> belgiga kelsak: belgini faqat joy uchun ball talablari bajarilganda olish mumkin va uni qolgan joylar uchun boshqa nishonlarga almashtirish mumkin emas.<br/><br/>- Tangalarga kelsak: agar foydalanuvchi joylardan birini yutsa, masalan (foydalanuvchi eng yaxshi 1-o'rinni egallagan bo'lsa, lekin uning ballari, masalan, 500K, 800k dan kam, bu tangalarni olish uchun birinchi o'rin talabidir, bu holda u birinchi o'rin bosh kiyimini oladi + birinchi o'rin haydovchisi + birinchi o'rin belgisi + va u mumkin ikkinchi o'rin uchun tangalarni oling, chunki u ikkinchi o'rin uchun shartni bajardi, bu 400k dan ortiq).<br/><br/>- Belgiga kelsak: agar u 400K kabi 500K dan kam ball bilan eng yaxshi 1-o'rinni egallagan bo'lsa, bu hatto birinchi nishon ochkolaridan ham kam bo'lsa, u holda u birinchi o'rindagi bosh kiyim va haydovchiga ega bo'ladi, shuningdek, faqat ikkinchi o'rin tangalari, ya'ni nishonsiz mukofotlar."
  },
  fa: {
    pkking: 'پی کی کینگ',
    supporter: 'بوستر کینگ',
    room: 'اتاق',
    rewardKing: 'جوایز برای PK King',
    rewardSupporter: 'جوایز برای Booster',
    rewardRoom: 'جوایز برای اتاق',
    timeR: 'شمارش معکوس',
    days: 'روزها',
    rule: 'قوانین',
    lastweek: 'سه نفر اول هفته گذشته',
    thisweek: 'رتبه این هفته',
    rule1:
      '1. دوره فعالیت هفتگی از ساعت 0:00 یکشنبه تا 23:59:59 شنبه به وقت KSA است. (نمرات بلافاصله قبل از پایان شمارش معکوس در چرخه هفتگی محاسبه خواهد شد)',
    rule2: '2. PK King بر اساس نمرات کسب شده در مسابقه PK رتبه‌بندی می‌شود.',
    rule3: '3. Booster King بر اساس نمرات داده شده در مسابقه PK رتبه‌بندی می‌شود.',
    rule4: '4. استفاده از هدایا در سایر فعالیت‌ها برای شرکت در PK، امتیازهای مربوطه در لیست PK محاسبه نخواهد شد.',
    HonorList: 'لیست افتخار',
    rule5: '5. در هر مسابقه، برنده 3% سهم دریافت خواهد کرد.',
    service: 'اگر سوالی دارید، لطفاً برای تماس با خدمات مشتری اینجا کلیک کنید.',
    rewardtitle: 'قوانین جوایز',
    rewardRule:
      '- در مورد کلاه‌خود و ماشین: شما می‌توانید کلاه‌خود و ماشین را بردارید، هر پستی که کاربر برنده شده است.<br/><br/>- در مورد نشان: نشان تنها در صورتی قابل دریافت است که امتیاز پست برنده شده توسط کاربر تکمیل شده باشد، و نمی‌توان آن را برای نشان‌های دیگر مراکز تعویض کرد.<br/><br/>- در مورد سکه‌ها: در صورتی که کاربر یکی از مراکز را برنده شود، برای مثال (کاربری که مقام اول را برنده شده است، اما امتیاز او، برای مثال 500k، کمتر از 800k است که برای دریافت سکه‌ها لازم است، در این صورت او کلاه‌خود اول + ماشین اول + نشان اول را خواهد گرفت + و او می‌تواند سکه‌های مقام دوم را دریافت کند زیرا شرط سکه مقام دوم که بیش از 400k است را برآورده کرده است).<br/><br/>اما در صورتی که او مقام اول را با کمتر از 500k امتیاز برنده شده باشد، برای مثال 400k که حتی کمتر از امتیاز نشان اول است، در این صورت او فقط کلاه‌خود و ماشین مقام اول را خواهد گرفت و فقط سکه‌های مقام دوم را دریافت خواهد کرد، به این معنی که جوایز بدون نشان است.'
  },
  ur: {
    pkking: 'PK کنگ',
    supporter: 'بوسٹر کنگ',
    room: 'روم',
    rewardKing: 'PK کنگ کے انعامات',
    rewardSupporter: 'بوسٹر کے انعامات',
    rewardRoom: 'روم کے انعامات',
    timeR: 'کاؤنٹ ڈاؤن',
    days: 'دن',
    rule: 'قواعد',
    lastweek: 'گزشتہ ہفتے کے ٹاپ 3',
    thisweek: 'اس ہفتے کی درجہ بندی',
    rule1: '1. ہفتہ وار سرگرمی کا دورانیہ اتوار کی رات 12 بجے سے ہفتہ کی رات 11:59:59 تک، KSA وقت کے مطابق ہوتا ہے۔ (کاؤنٹ ڈاؤن کے بالکل اختتام سے پہلے کے اسکور ہفتہ وار سائیکل میں شامل کیے جائیں گے)',
    rule2: '2. PK کنگ کی درجہ بندی PK مقابلے میں حاصل کردہ اسکور کے مطابق ہوتی ہے۔',
    rule3: '3. بوسٹر کنگ کی درجہ بندی PK مقابلے میں دیے گئے اسکور کے مطابق ہوتی ہے۔',
    rule4: '4. PK میں حصہ لینے کے لیے دیگر تمام سرگرمیوں میں تحائف کا استعمال کرنے پر، متعلقہ اسکور PK لسٹ میں شمار نہیں ہوں گے۔',
    HonorList: 'اعزازی فہرست',
    rule5: '5. ہر مقابلے میں، فاتح کو 3% شیئر ملے گا۔',
    service: 'اگر آپ کے کوئی سوالات ہیں، تو براہ کرم کسٹمر سروس سے رابطہ کرنے کے لیے یہاں کلک کریں۔',
    rewardtitle: 'انعام کے قواعد',
    rewardRule: `
    - ہیڈ ویئر اور گاڑی کے متعلق: آپ ایک ہیڈ ویئر اور ایک گاڑی لے سکتے ہیں، چاہے صارف نے کسی بھی پوزیشن میں جیت حاصل کی ہو۔<br/><br/>
    - بیج کے متعلق: بیج صرف اس صورت میں لیا جا سکتا ہے جب صارف نے جیتنے والی پوزیشن کے پوائنٹس مکمل کیے ہوں، اور یہ کسی دوسرے بیج کے بدلے نہیں دیا جا سکتا۔<br/><br/>
    - سکے کے متعلق: اگر صارف نے کسی ایک پوزیشن میں جیت حاصل کی ہے، مثال کے طور پر (ایک صارف نے پہلی پوزیشن حاصل کی، لیکن اس کے پوائنٹس، مثال کے طور پر 500k، جو کہ 800k سے کم ہیں جو سکے حاصل کرنے کی ضروریات ہیں، اس صورت میں وہ پہلی پوزیشن کا ہیڈ ویئر + پہلی پوزیشن کی گاڑی + پہلی پوزیشن کا بیج + اور دوسری پوزیشن کے سکے حاصل کر سکتا ہے کیونکہ اس نے دوسری پوزیشن کے سکے کی شرط پوری کی ہے، جو کہ 400k سے زیادہ ہے)۔<br/><br/>
    لیکن اگر وہ پہلی پوزیشن میں جیتا ہے لیکن اس کے پوائنٹس 500k سے کم ہیں، مثال کے طور پر 400k جو کہ پہلے بیج کے پوائنٹس سے بھی کم ہیں، اس صورت میں وہ صرف پہلی پوزیشن کا ہیڈ ویئر اور گاڑی اور دوسری پوزیشن کے سکے ہی لے سکتا ہے، جس کا مطلب ہے کہ انعامات بیج کے بغیر ہوں گے۔
    `
  }
}



// WEBPACK FOOTER //
// src/pages/activity/pkactivity/lang.js